import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { updateUserConfigurationAndService } from 'owa-userconfiguration/lib/utils/updateUserConfigurationAndService';
import { logUsage } from 'owa-analytics';

/**
 * Sets the folder pane width in the local user config and makes a call to update it in server userConfig
 * @param newFolderPaneWidth the width of navigation pane
 */
export default function setFolderPaneWidth(newFolderPaneWidth: number): void {
    const storedFolderPaneWidth = getUserConfiguration().UserOptions?.NavigationBarWidth;

    // Width did not change
    if (storedFolderPaneWidth == newFolderPaneWidth) {
        logUsage('FP_SetFolderPaneWidth_SameValue', { newFolderPaneWidth });
        return;
    }

    logUsage('FP_SetFolderPaneWidth_NewValue', {
        storedFolderPaneWidth,
        newFolderPaneWidth,
    });

    updateUserConfigurationAndService({
        UserOptions: {
            NavigationBarWidth: newFolderPaneWidth,
        },
    });
}
